<template>
    <div class="bulma">
        <div class="modal"
             :class="{ 'is-active': isShown }"
             v-if="isUserCanWrite">
            <div class="modal-background" @click="hide"></div>
            <div class="modal-card">
            <header class="modal-card-head">
                <svg class="modal-card-icon">
                    <use xlink:href="#icon-link"></use>
                </svg>
                <h2 class="modal-card-title">{{ trans.title }}</h2>
                <button class="delete" aria-label="close" @click="hide"></button>
            </header>
            <section class="modal-card-body">
                <div v-if="isEmpty">
                    {{ trans.open_document_first }}
                </div>
                <div v-else>
                    <article class="message is-success" v-show="isCopied">
                        <div class="message-body">{{ trans.message_success }}</div>
                    </article>

                    {{ trans.message_body }}

                    <label class="checkbox" v-if="isUserCanWrite">
                        <i class="fas fa-spinner fa-spin" v-show="isLoading"></i>
                        <input type="checkbox" :disabled="isLoading" v-model="isPublicLink" v-show="!isLoading">

                        {{ trans.message_checkbox }}

                    </label>
                </div>
                </section>
                <footer class="modal-card-foot">
                    <button
                        v-if="!isEmpty"
                        class="button is-info"
                        @click="copyToClipBoard"
                    >
                        {{ trans.button_get }}
                    </button>
                    <button
                        class="button"
                        @click="hide"
                    >
                        {{ trans.button_close }}
                    </button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "ShareLinkModal",
    props: {
        trans: Object,
    },
    data() {
        return {
            utils: Utils,
            isPublicLink: false,
            isUserCanWrite: false,
            isCopied: false,
            isLoading: false,
            isInit: false,
            isEmpty: true,
        };
    },
    computed: {
        ...mapGetters('shareLink', {
            isShown: 'shareLinkModalIsShown',
        }),
    },
    methods: {
        ...mapActions('shareLink', [
            'hideShareLinkModal',
        ]),
        hide() {
            this.hideShareLinkModal();
            this.isCopied = false;
        },
        generateLink() {
            let documentUrl = actions.publicLink,
                documentHash = getContentHash(),
                url = this.replaceWildcards(documentUrl, { document_hash: documentHash });

            return url;
        },
        copyToClipBoard() {
            let url = this.generateLink();
            let el = document.createElement('textarea');

            el.value = url;
            document.body.appendChild(el);

            // Выделим текст в поле
            el.select();
            // Для мобильных устройств
            el.setSelectionRange(0, url.length);

            document.execCommand('copy');
            this.isCopied = true;
            document.body.removeChild(el);
        },
    },
    watch: {
        isPublicLink(newValue, oldValue) {
            if (this.isInit) {
                this.isInit = false;
                return;
            }
            this.isLoading = true;

            let documentHash = getContentHash();
            let endPointUrl  = this.replaceWildcards(actions.share, { 'document_hash': documentHash});

            axios.patch(endPointUrl, { state: newValue })
                .finally(() => {
                    sendGAEvent('Был изменен статус публичного доступа к документу');
                    setTimeout(() => {
                        documentInfo.isPublic = newValue;
                        this.isLoading = false;
                    }, 1000)
                });
        },
        isShown(newValue, oldValue) {
            if (newValue) {
                if (!permissions.document.isUserCanWrite) {
                    this.copyToClipBoard();
                    Utils.showModalAnnounce($(kbSelector.noticeNode), trans.settings.link_to_clipboard_success);
                    return;
                }

                if (getContentHash()) {
                    this.isEmpty = false;
                }

                if (permissions.document.isUserCanWrite) {
                    this.isUserCanWrite = true;
                }

                if (documentInfo.isPublic != this.isPublicLink) {
                    this.isInit = true;
                    this.isPublicLink = documentInfo.isPublic;
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
    .checkbox {
      padding-top: 15px;
    }
</style>
